module.exports = __webpack_public_path__ + "media/landing_page/apple-icon-07713f4c.svg";